import React, { useState, useEffect } from 'react';
import { offersAPI, peekCache } from '../services/api';
import LoadingSpinner from '../components/LoadingSpinner';
import SourceCard, { SourceGrid } from '../components/SourceCard';
import { PageHeader, Alert, syncServerClock } from '../ui';

// Індекс джерел: список береться з реєстру Source на бекенді, а не з хардкоду —
// новий парсер з'являється тут сам, без правок фронта.
const CompetitorsPage = () => {
    const cached = peekCache('/offers/dashboard', { recent_hours: 24 });
    const [sources, setSources] = useState(cached?.sources || []);
    const [recentHours, setRecentHours] = useState(cached?.recent_hours || 24);
    const [loading, setLoading] = useState(!cached);
    const [error, setError] = useState(null);

    useEffect(() => {
        (async () => {
            try {
                const data = await offersAPI.dashboard();
                syncServerClock(data.now);
                setSources(data.sources || []);
                setRecentHours(data.recent_hours || 24);
            } catch (e) {
                setError('Не вдалося завантажити список джерел.');
            } finally {
                setLoading(false);
            }
        })();
    }, []);

    return (
        <div className="ui-page">
            <PageHeader
                title="Конкуренти"
                description="Обери джерело, щоб переглянути каталог, запустити збір і подивитись історію цін."
            />

            {error && <Alert kind="error">{error}</Alert>}

            {loading ? <LoadingSpinner /> : (
                <>
                    <SourceGrid>
                        {sources.map((s, i) => <SourceCard key={s.source_key} source={s} index={i} />)}
                    </SourceGrid>
                    <div className="muted" style={{ fontSize: 13 }}>
                        Зміни цін — за останні {recentHours} год.
                    </div>
                </>
            )}
        </div>
    );
};

export default CompetitorsPage;
